import { render, staticRenderFns } from "./MainBoxItem.vue?vue&type=template&id=408c9804&scoped=true&"
import script from "./MainBoxItem.vue?vue&type=script&lang=js&"
export * from "./MainBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./MainBoxItem.vue?vue&type=style&index=0&id=408c9804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c9804",
  null
  
)

export default component.exports